"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props) {
  var wrap = {};
  var palette = theme.palette;

  if (!props.multiline) {
    wrap = {
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    };
  }

  return {
    root: {
      position: 'relative',
      display: theme.display
    },
    content: _objectSpread({
      minHeight: props.closeAvailable ? "".concat(palette.gutter * 5, "px") : 'none',
      display: 'block',
      position: 'absolute',
      top: '10px',
      background: theme.background,
      boxSizing: 'border-box',
      border: theme.border,
      boxShadow: theme.boxShadow,
      borderRadius: theme.borderRadius,
      zIndex: theme.zIndex,
      minWidth: theme.minWidth,
      width: theme.width,
      maxWidth: theme.maxWidth,
      left: 0,
      whiteSpace: 'normal',
      color: theme.color,
      padding: theme.padding,
      textAlign: theme.textAlign
    }, wrap, {
      '&:after': {
        position: 'absolute',
        content: '""',
        display: 'block',
        width: 0,
        height: 0,
        left: '10px',
        top: '-10px',
        zIndex: palette.zOverlay,
        border: '5px solid transparent',
        borderBottomColor: palette.elPrimary
      }
    }),
    close: {
      position: 'absolute',
      top: palette.gutter + 'px',
      right: palette.gutter + 'px',
      display: 'inline-block',
      cursor: 'pointer'
    },
    closeIcon: {
      display: 'flex'
    }
  };
}